const allowedQueryParams = [
  'testcafe',
  'amount',
  'loanAmount',
  'repay',
  'repaymentYears',
  'op_user_id',
  'locale'
]

/**
 * @param {string} name
 * @param {string} brand
 * @param {string} country
 * @param {object} fragments
 * @param {object|null} route
 * @param {string|null} slug
 * @returns {*}
 */
function getFragment ({ name, brand, country, fragments = {}, route = null, slug = null } = {}) {
  if (!name) return

  const fragmentSsi = fragments?.ssi?.[name]
  const fragmentSsr = fragments?.ssr?.[name]

  if (!fragmentSsi && !fragmentSsr) return

  let url = ''
  let type = ''
  let params = ''

  const host = route?.host
  const path = route?.path
  const referer = route?.referer?.split('?')?.[0]
  const query = route?.query

  if (fragmentSsi) {
    url = fragmentSsi
    type = 'ssi'
  }

  if (fragmentSsr) {
    url = fragmentSsr
    type = 'ssr'
  }

  if (slug) url = `${url}${slug}`

  if (fragmentSsr) {
    if (host) {
      params += `&host=${host}`
    }

    if (path) {
      params += `&path=${path}`
    }

    if (referer) {
      params += `&referer=${referer}`
    }

    if (query) {
      for (const [key, value] of Object.entries(query)) {
        if (!allowedQueryParams.includes(key)) continue
        params = `${params}&${key}=${value}`
      }
    }
  }

  url = `${url}${params}`
  url = !url.includes('?') ? url.replace('&', '?') : url

  url = url
    .replace(/{brand}/g, brand)
    .replace(/{country}/g, country)

  return {
    url,
    type
  }
}

module.exports = { getFragment }
